import Vue from "vue";
import infoo from "../plugins/infoo";

// combinamos los datos de los items que coinciden
function combineHls(hls, info) {
  let tempHls = JSON.parse(JSON.stringify(hls));
  // info.i = ini, info.e = end
  tempHls.push({ i: info.i, e: info.e, cl: info.cl });

  // recorre el array con dos indices A y B
  for (let a = 0; a < tempHls.length; a++) {
    let combine = false;

    // asigna cada resaltado a su indice iA
    const iA = tempHls[a];

    for (let b = 0; b < tempHls.length; b++) {
      // asigna iB para resaltado del indice B
      const iB = tempHls[b];

      // evaluamos las diferentes posibilidades de combinacion
      if (a !== b) {
        // A inicia ANTES inicia B y A termina DESPUES inicia B
        // ------------AaaaaA----------------------------------
        // --------------Bbbbbb--------------------------------
        if (iA.i <= iB.i && iA.e >= iB.i) combine = true;

        // A inicia DESPUES inicia B y A termina ANTES termine B
        // -----------------AaaaA-------------------------------
        // ----------------BbbbbbB------------------------------
        if (iA.i >= iB.i && iA.e <= iB.e) combine = true;

        // A inicia DESPUES inicia B y A inicia ANTES termine B
        // ------------------Aaaaaaa---------------------------
        // ----------------BbbbbbB-----------------------------
        if (iA.i >= iB.i && iA.i <= iB.e) combine = true;

        // A termina 1 antes del inicio de B
        // --------aaaaaaA#-----------------
        // ---------------Bbbbbbbb----------
        if (iA.e + 1 === iB.i) combine = true;

        // A inicia 1 despues del final de B
        // --------------#Aaaaaa------------
        // -------bbbbbbbB------------------
        if (iA.i - 1 === iB.e) combine = true;
      }
      if (combine) {
        // Determinamos el minimo y maximo
        let min = iA.i < iB.i ? iA.i : iB.i;
        let max = iA.e > iB.e ? iA.e : iB.e;

        // combinamos los valores
        iA.i = min;
        iB.i = min;
        iA.e = max;
        iB.e = max;
      }
    }
  }

  // creamos nuevo array y ordenamos
  tempHls = tempHls.sort((a, b) => {
    if (a.i < b.i) return -1;
    if (a.i > b.i) return 1;
    return 0;
  });

  let newHls = [];
  tempHls.forEach(item => {
    let index = newHls.findIndex(i => {
      return item.i === i.i;
    });

    // TODO: omite el ultimo hl despues de combinar varios hls antes al ultimo
    if (index === -1) newHls.push(item);
  });

  // devolvemos el array ordenado
  return newHls;
}

function contarHls(lngVerHls) {
  var cant = 0;
  Object.keys(lngVerHls).forEach(k => {
    if (k !== "cant") {
      cant = cant + lngVerHls[k].hls.length;
    }
  });
  return cant;
}

function eliminarIndex(arr, idx) {
  var newArr = JSON.parse(JSON.stringify(arr));
  newArr.splice(idx, 1);
  return newArr;
}

const notes = {
  namespaced: true,
  state: {
    def: {
      _uid: "",
      _exists: false,
      _changes: false,
      _time: 0,
      _sync: 0,
      alm: "", // alarma compromiso
      dd: 0, // day
      dm: 0, // month
      dy: 0, // year
      cd: 0, // completeDay
      cn: 0, // completeNight
      hl: {}, // version, es una suma acumulativa en tiempo de ejecucion
      ora: "", // oracion personal
      com: "", // compromisos
      cok: 1,
      txts: [], // textos biblicos {txt, vdm true || false}
      vdm: "" // voz de la misericordia
    },
    defCopia: {
      _uid: "",
      _exists: false,
      _changes: false,
      _time: 0,
      _sync: 0,
      alm: "", // alarma compromiso
      dd: 0, // day
      dm: 0, // month
      dy: 0, // year
      cd: 0, // completeDay
      cn: 0, // completeNight
      hl: {
        def: {
          _cant: 0,
          _ver: 1,
          pr: { min: 0, max: 0, sum: 0, hls: [] },
          rs: { min: 0, max: 0, sum: 0, hls: [] },
          sa: { min: 0, max: 0, sum: 0, hls: [] },
          se: { min: 0, max: 0, sum: 0, hls: [] },
          ev: { min: 0, max: 0, sum: 0, hls: [] }
        },
        ver: 0 // version, es una suma acumulativa en tiempo de ejecucion
      },
      ora: "", // oracion personal
      com: "", // compromisos
      vdm: "" // voz de la misericordia
    },
    items: {}
  },
  getters: {
    def(state) {
      return state.def;
    },
    defHl(state) {
      return state.def.hl.def;
    },
    hlId(state) {
      // ids: docId documento y lectioCod
      return ids => {
        if (
          state.items[ids.docId] &&
          state.items[ids.docId].hl[ids.lectioCod]
        ) {
          return state.items[ids.docId].hl[ids.lectioCod];
        } else {
          return state.def.hl.def;
        }
      };
    },
    item(state) {
      return id => {
        if (id !== "" && state.items[id]) {
          return state.items[id];
        } else {
          return state.def;
        }
      };
    },
    items(state) {
      return state.items;
    }
  },
  mutations: {
    // operaciones en vuex, siempre posteriores a operaciones en firestore
    afterUploadChanges(state, uids) {
      uids.forEach(uid => {
        state.items[uid]._exists = true;
        state.items[uid]._changes = false;
      });
    },
    clearData(state) {
      let hoy = infoo.hoy;
      Vue.set(state, "items", {});
      state.selected = "";
      state.selectedYear = hoy.anio;
      state.selectedMonth = hoy.mes;
    },
    // se omite por ahora
    prepareHlFor(state, payload) {
      // id: cod:
      if (state.items[payload.id]) {
        if (!state.items[payload.id].hl[payload.cod]) {
          let def = JSON.parse(JSON.stringify(state.def.hl.def));
          def.cod = payload.cod;
          state.items[payload.id].hl[payload.cod] = def;
        }
      }
    },
    loadFromWeb(state, docs) {
      // este commit funciona para cargar documentos descargados desde fb
      // docs: [doc: {id: "2020-01-30", data: {}}]
      // combina defaultData + docData
      let data;
      let docData;
      let defData = JSON.parse(JSON.stringify(state.def)); // default values

      docs.forEach(doc => {
        // combinamos la informacion
        docData = typeof doc.data === "function" ? doc.data() : doc.data;
        data = Object.assign(defData, docData, {
          _uid: doc.id, // id es definido por fb
          _exists: doc.exists
        });

        // asignamos la propiedad al objeto items
        Vue.set(state.items, doc.id, data);
      });
    },
    loadLocalDoc(state, payload) {
      // payload = { localUid: payload.localUid, data: def }
      Vue.set(state.items, payload.data._uid, payload.data);
      this.$local.set(payload.localUid, payload.data);
    },
    update(state, payload) {
      // payload: {id: "2020-03-30", uidLocal: "", data: {noteObject}}
      let item = state.items[payload.id] || false;
      if (!item) return "";

      // combinamos la informacion
      let oldData = item || {};
      let newData = payload.data || {};
      let data = Object.assign(oldData, newData, {
        _changes: true
      });

      // asignamos la propiedad al objeto items
      Vue.set(state.items, payload.id, data);
      this.$local.set(payload.uidLocal, state.items[payload.id]);
    },
    updateHl(state, payload) {
      // payload: {id: "2020-03-30", cod: "esco || es" info: {hlObject}}

      // validar y asignar variables de contenido - - - - - - - - - - - - - - - - - - -
      let userNote = state.items[payload.docId] || false;
      if (!userNote || !payload.lectioCod) return "";

      let codigoLngVer = payload.lectioCod;
      if (userNote.hl[codigoLngVer] === undefined) {
        // userNote.hl.esco
        Vue.set(userNote.hl, codigoLngVer, { cant: 0 });
      }

      let lngVerHls = userNote.hl[codigoLngVer];
      let field = payload.info.field;
      if (lngVerHls[field] === undefined) {
        Vue.set(lngVerHls, field, { ver: 0 }); // hl.es.ev > evangelio
      }
      // { min: 0, max: 0, sum: 0, hls: [] }

      let fieldData = lngVerHls[field]; // hl.es.ev = { min: 0, max: 0, ver: 0, cant: 0 hls: [] }
      fieldData.ver++; // lleva cuenta de los cambios, se usara para optimizar el renderizado de la directiva

      if (fieldData.hls === undefined) Vue.set(fieldData, "hls", []);
      // let hls = fieldData.hls; // hl.es.ev.hls > array de resaltados
      // hasta aqui validacion asignacion - - - - - - - - - - - - - - - - - - - - - - -

      // nuevos valores min y max _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _
      let min =
        fieldData.min !== undefined && fieldData.min <= payload.info.i
          ? fieldData.min
          : payload.info.i;
      let max =
        fieldData.max !== undefined && fieldData.max >= payload.info.e
          ? fieldData.max
          : payload.info.e;
      Vue.set(fieldData, "min", min);
      Vue.set(fieldData, "max", max);

      // combinar la informacion de los hls y asignarla _ _ _ _ _ _ _ _
      let newHls = combineHls(fieldData.hls, payload.info);
      Vue.set(fieldData, "hls", newHls);

      // actualizar _cant y version _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _
      lngVerHls.cant = contarHls(lngVerHls);

      // TODO: extraer texto para pasarlo al cuaderno.
      userNote._changes = true;
      this.$local.set(payload.uidLocal, userNote);
    },
    eliminarHl(state, payload) {
      // payload: {id: lectioCod: field: index}

      // validar y asignar variables de contenido - - - - - - - - - - - - - - - - - - -
      let userNote = state.items[payload.docId] || false;
      if (!userNote) return "";

      let lngVerHls = userNote.hl[payload.lectioCod] || false;
      if (!lngVerHls) return "";

      let field = lngVerHls[payload.field] || false;
      if (!field) return "";

      let hl = field.hls[payload.index] || false;
      if (!hl) return;

      // elimina el resaltado
      if (field.hls.length === 1) {
        Vue.delete(lngVerHls, payload.field);
      } else {
        let newHls = eliminarIndex(field.hls, payload.index);
        let min = undefined;
        let max = undefined;
        newHls.forEach(hl => {
          if (min === undefined) min = hl.i;
          if (max === undefined) max = hl.e;
          min = min < hl.i ? min : hl.i;
          max = max > hl.e ? max : hl.e;
        });
        field.min = min;
        field.max = max;
        Vue.set(field, "hls", newHls);
        field.ver++; // seguimiento a cambios, optimiza el render de la directiva
      }

      lngVerHls.cant--; // 0 indica que no tiene hl, oculta boton de borrado

      // variables de control
      userNote._changes = true;
      this.$local.set(payload.uidLocal, userNote);
    },
    extraerTxtsBiblicos(state, payload) {
      // payload: {docId: lectioCod: lectio}

      // validar y asignar variables de contenido - - - - - - - - - - - - - - - - - - -
      let userNote = state.items[payload.docId] || false;
      if (!userNote) return "";

      let lngVerHls = userNote.hl[payload.lectioCod] || false;
      if (!lngVerHls) return "";

      let vdm = userNote.vmd;

      const libroBiblia = /(.+)([(,].+)/;
      let extraeLibro = function(libro) {
        return libro.replace(libroBiblia, "$1");
      };

      const rexSpanRta = /<[^>]*>R.<[^>]*>/g;
      const rexHtmlLabels = /<[^>]*>/g;
      let limpiaHtml = function(txt) {
        let t;
        t = txt.replace(rexSpanRta, "");
        t = t.replace(rexHtmlLabels, "");
        t = t.replace("  ", " ");
        return t;
      };

      var txts = [];
      let extraeTxts = function(hls, lectura, libro) {
        hls.forEach(hl => {
          let txt = lectura.slice(hl.i, hl.e);
          let isVdm = txt === vdm;
          txts.push({
            txt: limpiaHtml(txt),
            lb: extraeLibro(libro),
            vdm: isVdm
          });
        });
      };

      if (lngVerHls.pr) {
        extraeTxts(
          lngVerHls.pr.hls,
          payload.lectio.txtPrimera,
          payload.lectio.lbPrimera
        );
      }
      if (lngVerHls.rs) {
        extraeTxts(
          lngVerHls.rs.hls,
          payload.lectio.rtaSalmo,
          payload.lectio.lbSalmo
        );
      }
      if (lngVerHls.sa) {
        extraeTxts(
          lngVerHls.sa.hls,
          payload.lectio.txtSalmo,
          payload.lectio.lbSalmo
        );
      }
      if (lngVerHls.se) {
        extraeTxts(
          lngVerHls.se.hls,
          payload.lectio.txtSegunda,
          payload.lectio.lbSegunda
        );
      }
      if (lngVerHls.ev) {
        extraeTxts(
          lngVerHls.ev.hls,
          payload.lectio.txtEvang,
          payload.lectio.lbEvang
        );
      }

      Vue.set(userNote, "txts", txts);
      this.$local.set(payload.uidLocal, userNote);
    },
    eligeVdm(state, payload) {
      // payload: {docId: lectioCod: lectio}

      // validar y asignar variables de contenido - - - - - - - - - - - - - - - - - - -
      let userNote = state.items[payload.docId] || false;
      if (!userNote) return "";

      let lngVerHls = userNote.hl[payload.lectioCod] || false;
      if (!lngVerHls) return "";

      userNote.txts.forEach(txt => {
        txt.vdm = false;
      });

      userNote.txts[payload.index].vdm = true;
      userNote.vdm = userNote.txts[payload.index].txt;

      this.$local.set(payload.uidLocal, userNote);
    },
    compromisoOk(state, payload) {
      // payload: {docId: lectioCod: lectio}

      // validar y asignar variables de contenido - - - - - - - - - - - - - - - - - - -
      let userNote = state.items[payload.docId] || false;
      if (!userNote) return "";

      switch (userNote.cok) {
        case 1:
          userNote.cok = 2;
          break;
        case 2:
          userNote.cok = 3;
          break;
        case 3:
          userNote.cok = 1;
      }

      this.$local.set(payload.uidLocal, userNote);
    }
  },
  actions: {
    createLocalDoc({ commit, getters }, payload) {
      // payload = {uid: uid, localUid: localUid, params: params}
      let def = getters.def;

      def._uid = payload.uid;
      def.dd = payload.params.dia;
      def.dm = payload.params.mes;
      def.dy = payload.params.anio;

      commit("loadLocalDoc", { localUid: payload.localUid, data: def });
    },
    getLocalDocs({ dispatch }, docs) {
      // docs array de docs
      docs.forEach(doc => {
        dispatch("getLocalDoc", infoo.fechaIso(doc));
      });
    },
    getLocalDoc({ commit, dispatch, getters, rootGetters }, params) {
      // generar uid
      let mes = params.mes < 10 ? "0" + params.mes : params.mes;
      let dia = params.dia < 10 ? "0" + params.dia : params.dia;
      let uid = params.anio + "-" + mes + "-" + dia;

      // confirmar si ya existe en vuex
      let items = getters["items"];
      if (items[uid] !== undefined) return;

      // cargar el documento local
      let userAuth = rootGetters["user/auth"];
      let localUid = "user/" + userAuth.uid + "/notes/" + uid;
      let userNote = this.$local.get(localUid);

      if (userNote) {
        commit("loadLocalDoc", {
          localUid: localUid,
          data: userNote
        });
      } else {
        dispatch("createLocalDoc", {
          uid: uid,
          localUid: localUid,
          params: params
        });
      }
    },
    getLocalDocsAntesDe({ commit, rootGetters }, payload) {
      // payload {fecha, cant}
      const userAuth = rootGetters["user/auth"];
      // fMinima por defecto el lanzamiento de la app
      const fMinima = userAuth.created || "2020-05-01";

      const diaAntes = function(dia) {
        let arr = dia.split("-");
        let fechaDia = new Date(arr[0], arr[1] - 1, arr[2], 0, 0, 0, 0);
        let fechaAnt = new Date(fechaDia.getTime() - 24 * 60 * 60 * 1000);
        return fechaAnt.toISOString().slice(0, 10);
      };

      var fechaDoc = diaAntes(payload.fecha);

      for (let i = 1; i < payload.cant; i++) {
        if (fechaDoc < fMinima) {
          return "No hay más";
        } else {
          let localUid = "user/" + userAuth.uid + "/notes/" + fechaDoc;
          let userNote = this.$local.get(localUid);

          if (userNote) {
            commit("loadLocalDoc", {
              localUid: localUid,
              data: userNote
            });
          }
        }
        fechaDoc = diaAntes(fechaDoc);
      }

      return "cargado";
    },
    getDocFromWeb({ commit, dispatch, getters, rootGetters }, params) {
      // params: {anio: mes: dia:}
      let appReady = rootGetters["app/resources"] === 100;
      let userReady = rootGetters["user/ready"];

      // TODO: limitar consultar ususario sin suscripcion
      if (!appReady || userReady) {
        commit(
          "app/loadBefore",
          { dispatch: "user/notes/getDocFromWeb", payload: params },
          { root: true }
        );
        return "";
      }

      // generar uid
      let mes = params.mes < 10 ? "0" + params.mes : params.mes;
      let dia = params.dia < 10 ? "0" + params.dia : params.dia;
      let uid = params.anio + "-" + mes + "-" + dia;

      let items = getters["items"];
      if (items[uid] !== undefined) return;

      let userNotes = this.$collection.userNotes;
      userNotes
        .doc(uid)
        .get()
        .then(doc => {
          if (doc.exists) {
            commit("load", [doc]);
          } else {
            let newDoc = {
              id: uid, // formato de fb
              exists: false,
              data: {
                dd: params.dia,
                dm: params.mes,
                dy: params.anio
              }
            };
            commit("load", [newDoc]);
          }
        })
        .catch(e => {
          dispatch(
            "app/saveErrorReport",
            { e: e, line: 315, src: "user_note.js" },
            { root: true }
          );
        });
    },
    getDocsFromWeb({ commit, dispatch, rootGetters }, where) {
      let appReady = rootGetters["app/resources"] === 100;
      let userReady = rootGetters["user/ready"];
      if (!appReady || userReady) {
        commit(
          "app/loadBefore",
          { dispatch: "user/notes/getDocFromWeb", payload: where },
          { root: true }
        );
        return "";
      }

      // si no tiene consulta, usar default
      if (!where) {
        let hoy = infoo.hoy;
        where = {
          anio: hoy.anio,
          mes: hoy.mes
        };
      }

      let userNotes = this.$collection.userNotes;

      userNotes
        .where("dy", "==", where.anio)
        .where("dm", "==", where.mes)
        .get()
        .then(qSnap => {
          commit("loadFromWeb", { docs: qSnap.docs });
        })
        .catch(e => {
          dispatch(
            "app/saveErrorReport",
            { e: e, line: 346, src: "user_note.js" },
            { root: true }
          );
        });
    },
    update({ commit, getters, rootGetters }, doc) {
      // doc: {id: "2020-01-30"}

      // let auth = rootGetters["user/auth"].uid;
      let hasActivePlan = rootGetters["user/hasActivePlan"];
      if (!hasActivePlan) return "";

      // validamos si existe el item
      let item = getters.items[doc.id];
      if (!item) return "";

      let userNotes = this.$collection.userNotes;
      let data = JSON.parse(JSON.stringify(item));
      delete data._uid;
      delete data._exists;
      delete data._changes;

      if (item._exists) {
        userNotes
          .doc(item._uid)
          .update(data)
          .then(() => {
            commit("afterUploadChanges", [item._uid]);
          });
      } else {
        userNotes
          .doc(item._uid)
          .set(data)
          .then(() => {
            commit("afterUploadChanges", [item._uid]);
          });
      }
    },
    uploadChanges({ commit, getters, rootGetters }) {
      // eslint-disable-next-line
      // let auth = rootGetters["user/auth"].uid;
      let hasActivePlan = rootGetters["user/hasActivePlan"];
      if (!hasActivePlan) return "";

      // validamos si existe el item
      let items = getters.items;
      let uids = [];
      items.forEach(item => {
        if (item._changes) uids.push(item._uid);
      });

      let userNotes = this.$collection.userNotes;
      var bacth = this.$fb.firestore().batch();

      uids.forEach(uid => {
        let ref = userNotes.doc(uid);
        let data = JSON.stringify(JSON.parse(items[uid]));
        delete data._uid;
        delete data._exists;
        delete data._changes;

        if (items[uid]._exists) {
          bacth.update(ref, data);
        } else {
          bacth.set(ref, data);
        }
      });

      bacth
        .commit()
        .then(() => {
          commit("afterUploadChanges", uids);
        })
        .catch(e => {
          this.$store.dispatch("app/saveErrorReport", {
            file: "user_notes.vue",
            line: 423,
            e: e
          });
        });
    }
  }
};

export default notes;
